import React, { useState } from "react";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import TokenRing, { getTokenPercentageColor } from "../common/TokenRing";

const TokensTab = ({ availableTokens, totalTokens }) => {
  const [customTokenAmount, setCustomTokenAmount] = useState("");
  const [customTokenPrice, setCustomTokenPrice] = useState("");
  const [customTokenError, setCustomTokenError] = useState("");

  // Calculate token percentage
  const tokenPercentage = totalTokens > 0 ? Math.round((availableTokens / totalTokens) * 100) : 0;

  // Calculate custom token price (example pricing logic)
  const calculateCustomTokenPrice = (amount) => {
    if (!amount || isNaN(amount) || amount <= 0) {
      setCustomTokenPrice("");
      return;
    }
    
    // Calculate tiered pricing
    let price;
    if (amount < 100) {
      price = (amount * 0.07).toFixed(2); // $0.07 per token for small amounts
    } else if (amount < 500) {
      price = (amount * 0.06).toFixed(2); // $0.06 per token for medium amounts
    } else if (amount < 1000) {
      price = (amount * 0.05).toFixed(2); // $0.05 per token for larger amounts
    } else {
      price = (amount * 0.045).toFixed(2); // $0.045 per token for very large amounts
    }
    
    setCustomTokenPrice(price);
  };
  
  const handleCustomTokenChange = (e) => {
    const value = e.target.value;
    setCustomTokenAmount(value);
    
    // Validate input
    if (value && (isNaN(value) || parseInt(value) <= 0)) {
      setCustomTokenError("Please enter a valid positive number");
    } else if (value && parseInt(value) > 10000) {
      setCustomTokenError("Maximum 10,000 tokens allowed per purchase");
    } else {
      setCustomTokenError("");
      calculateCustomTokenPrice(value);
    }
  };

  return (
    <div className="animate-fadeIn">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-6">Token Management</h2>
      
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl overflow-hidden mb-8 border border-gray-200 dark:border-gray-700">
        <div className="flex flex-col items-center justify-center px-8 py-10 bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900">
          <div className="relative" style={{ width: '220px', height: '220px' }}>
            <TokenRing percentage={tokenPercentage} size={220} />
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className={`flex flex-col items-center ${getTokenPercentageColor(tokenPercentage).text}`}>
                <span className="text-5xl font-bold">{availableTokens}</span>
                <div className="flex items-center mt-1">
                  <span className="text-sm opacity-80 font-medium">of</span>
                  <span className="text-lg ml-1 font-semibold opacity-90">{totalTokens}</span>
                </div>
              </div>
              <span className="mt-2 text-sm text-gray-500 dark:text-gray-400 font-medium">
                Tokens Available
              </span>
            </div>
          </div>
        </div>
      </div>
      
      {/* <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-6 flex items-center">
        <HiOutlineCurrencyDollar className="h-5 w-5 mr-2 text-green-500" />
        Purchase Tokens
      </h3> */}
      
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[
          { amount: 100, price: "$5.99", popular: false },
          { amount: 500, price: "$24.99", popular: true },
          { amount: 1000, price: "$44.99", popular: false }
        ].map((plan, index) => (
          <div 
            key={index} 
            className={`bg-white dark:bg-gray-800 rounded-lg overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${plan.popular ? 'ring-2 ring-blue-500' : 'border border-gray-200 dark:border-gray-700'} relative`}
          >
            {plan.popular && (
              <div className="absolute top-0 inset-x-0 flex justify-center">
                <span className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-bold py-1 px-4 rounded-b-md shadow-md">
                  BEST VALUE
                </span>
              </div>
            )}
            <div className={`p-6 ${plan.popular ? 'pt-8' : ''}`}>
              <div className="flex items-baseline">
                <div className="text-3xl font-bold text-gray-800 dark:text-white">{plan.amount}</div>
                <div className="ml-1 text-lg text-gray-500 dark:text-gray-400">tokens</div>
              </div>
              <div className="mt-4 mb-6">
                <div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">{plan.price}</div>
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  ${(parseFloat(plan.price.replace('$', '')) / plan.amount).toFixed(3)} per token
                </div>
              </div>
              <button className="w-full py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-md">
                Purchase
              </button>
            </div>
          </div>
        ))}
      </div> */}
      
      {/* <div className="bg-white dark:bg-gray-800 rounded-lg overflow-hidden shadow-xl p-6 mb-6 border border-gray-200 dark:border-gray-700">
        <div className="relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-gradient-to-br from-blue-400/10 to-purple-500/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-16 -left-16 w-48 h-48 bg-gradient-to-tr from-emerald-400/10 to-blue-500/10 rounded-full blur-3xl"></div>
          
          <h4 className="text-lg font-semibold text-gray-800 dark:text-white mb-6 relative">
            <span className="inline-block bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent">Custom Amount</span>
          </h4>
          
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 relative">
            <div className="lg:col-span-3 space-y-6">
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    Number of Tokens
                  </label>
                  {customTokenAmount && !customTokenError && (
                    <span className="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 px-2 py-1 rounded-full font-medium">
                      {parseFloat(customTokenPrice) / parseInt(customTokenAmount) < 0.05 ? "Best Value!" : ""}
                    </span>
                  )}
                </div>
                
                <div className="relative">
                  <input
                    type="number"
                    value={customTokenAmount}
                    onChange={handleCustomTokenChange}
                    min="1"
                    max="10000"
                    className="block w-full px-4 py-3 pr-20 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter amount (max 10,000)"
                  />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-gray-500 dark:text-gray-400">
                    tokens
                  </div>
                </div>
                
                {customTokenError && (
                  <p className="text-sm text-red-600 dark:text-red-400">{customTokenError}</p>
                )}
              </div>
              
              <div className="py-2">
                <input 
                  type="range" 
                  min="10" 
                  max="10000" 
                  step="10"
                  value={customTokenAmount || 10}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCustomTokenAmount(value);
                    setCustomTokenError("");
                    calculateCustomTokenPrice(value);
                  }}
                  className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-600"
                />
                <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-1">
                  <span>10 tokens</span>
                  <span>10,000 tokens</span>
                </div>
              </div>
              
              <div>
                <div className="text-xs text-gray-600 dark:text-gray-400 mb-2">Quick select:</div>
                <div className="flex flex-wrap gap-2">
                  {[50, 250, 750, 2000, 5000].map((amount) => (
                    <button 
                      key={amount}
                      onClick={() => {
                        setCustomTokenAmount(amount.toString());
                        setCustomTokenError("");
                        calculateCustomTokenPrice(amount);
                      }}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors duration-200 ${
                        customTokenAmount === amount.toString() 
                          ? 'bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300 border border-blue-200 dark:border-blue-800' 
                          : 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700'
                      }`}
                    >
                      {amount} tokens
                    </button>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-2 flex flex-col">
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-750 p-5 rounded-lg border border-blue-100 dark:border-blue-900/30 flex-grow flex flex-col">
                <div className="flex-grow space-y-3">
                  <h5 className="text-sm font-medium text-gray-700 dark:text-gray-300">Price Summary</h5>
                  
                  <div className="min-h-[80px] flex flex-col justify-center">
                    {customTokenPrice && !customTokenError ? (
                      <>
                        <div className="text-3xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 dark:from-emerald-400 dark:to-teal-300 bg-clip-text text-transparent">
                          ${customTokenPrice}
                        </div>
                        <div className="text-sm text-emerald-600 dark:text-emerald-400 font-medium flex items-center">
                          <span className="inline-block w-3 h-3 rounded-full mr-1 bg-emerald-500"></span>
                          ${(parseFloat(customTokenPrice) / parseInt(customTokenAmount)).toFixed(3)} per token
                        </div>
                      </>
                    ) : (
                      <div className="text-gray-500 dark:text-gray-400 italic">
                        Enter an amount to see pricing
                      </div>
                    )}
                  </div>
                  
                  {customTokenAmount && parseInt(customTokenAmount) >= 1000 && !customTokenError && (
                    <div className="bg-emerald-100 dark:bg-emerald-900/30 text-emerald-800 dark:text-emerald-300 text-xs p-2 rounded-md flex items-start">
                      <svg className="h-4 w-4 mr-1 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Volume discount applied for orders of 1,000+ tokens</span>
                    </div>
                  )}
                </div>
                
                <div className="mt-6">
                  <button 
                    className={`w-full py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-md flex items-center justify-center ${
                      (!customTokenAmount || customTokenError) ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-lg hover:-translate-y-0.5'
                    }`}
                    disabled={!customTokenAmount || customTokenError}
                  >
                    <HiOutlineCurrencyDollar className="h-5 w-5 mr-2" />
                    Purchase Tokens
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <div className="flex">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm text-blue-800 dark:text-blue-300">
            {/* Need more tokens? Contact our sales team at <span className="font-medium">sales@foodoscope.com</span> for enterprise plans with custom token allocations. */}
            Need more tokens? Contact us at <span className="font-medium">ganesh.bagler+foodoscope@gmail.com</span> for enterprise plans with custom token allocations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TokensTab; 